<template>
  <div class="empty-state" :class="{ 'empty-state--scrollable': scrollable }">
    <!-- 빈 상태 아이콘 -->
    <div class="empty-state__icon">
      <!-- 기본 아이콘 (박스) -->
      <svg
        v-if="iconType === 'default'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="8" y="8" width="48" height="48" rx="8" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <path d="M24 28H40M24 32H36M24 36H32" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <!-- 검색 결과 없음 -->
      <svg
        v-else-if="iconType === 'search'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="24" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <circle cx="28" cy="28" r="8" fill="none" stroke="#9CA3AF" stroke-width="2" />
        <path d="M34 34L40 40" stroke="#9CA3AF" stroke-width="2" stroke-linecap="round" />
        <path d="M20 44L44 20" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />
      </svg>

      <!-- 문서/파일 없음 -->
      <svg
        v-else-if="iconType === 'document'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="16" y="12" width="32" height="40" rx="2" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <path d="M24 24H40M24 28H36M24 32H38M24 36H32" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" />
        <circle cx="48" cy="16" r="6" fill="#EF4444" />
        <path d="M45 16H51" stroke="white" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <!-- 데이터/차트 없음 -->
      <svg
        v-else-if="iconType === 'chart'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="8" y="8" width="48" height="48" rx="8" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <path
          d="M16 40L24 32L32 36L48 24"
          stroke="#9CA3AF"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-dasharray="4 4"
        />
        <circle cx="24" cy="32" r="2" fill="#9CA3AF" />
        <circle cx="32" cy="36" r="2" fill="#9CA3AF" />
        <circle cx="48" cy="24" r="2" fill="#9CA3AF" />
      </svg>

      <!-- 알림 없음 -->
      <svg
        v-else-if="iconType === 'notification'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="24" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <path
          d="M24 32C24 28.4 27 25.6 30.4 25.1C30.1 24.4 30 23.7 30 23C30 20.8 31.8 19 34 19C36.2 19 38 20.8 38 23C38 23.7 37.9 24.4 37.6 25.1C41 25.6 44 28.4 44 32C44 35 45 37 45 37H23C23 37 24 35 24 32Z"
          stroke="#9CA3AF"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          d="M30 40C30 41.1 31.3 42 33 42C34.7 42 36 41.1 36 40"
          stroke="#9CA3AF"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path d="M20 44L44 20" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />
      </svg>

      <!-- 메시지 없음 -->
      <svg
        v-else-if="iconType === 'message'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="12" y="20" width="40" height="28" rx="6" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <path d="M20 28H44M20 32H36M20 36H40" stroke="#9CA3AF" stroke-width="1.5" stroke-linecap="round" />
        <path
          d="M32 48L28 52L32 48L36 52L32 48Z"
          fill="#F8F9FA"
          stroke="#D1D5DB"
          stroke-width="1.5"
          stroke-linejoin="round"
        />
        <circle cx="48" cy="16" r="6" fill="#EF4444" />
        <path d="M45 16H51" stroke="white" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <!-- 사용자 없음 -->
      <svg
        v-else-if="iconType === 'user'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="24" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <circle cx="32" cy="26" r="6" fill="none" stroke="#9CA3AF" stroke-width="1.5" />
        <path
          d="M22 42C22 38 26.5 35 32 35C37.5 35 42 38 42 42"
          stroke="#9CA3AF"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path d="M20 44L44 20" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />
      </svg>

      <!-- 폴더 없음 -->
      <svg
        v-else-if="iconType === 'folder'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 22L12 46C12 47.1 12.9 48 14 48L50 48C51.1 48 52 47.1 52 46L52 26C52 24.9 51.1 24 50 24L28 24L24 20L14 20C12.9 20 12 20.9 12 22Z"
          fill="#F8F9FA"
          stroke="#D1D5DB"
          stroke-width="1.5"
        />
        <circle cx="48" cy="16" r="6" fill="#EF4444" />
        <path d="M45 16H51" stroke="white" stroke-width="1.5" stroke-linecap="round" />
      </svg>

      <!-- 이미지 없음 -->
      <svg
        v-else-if="iconType === 'image'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="12" y="16" width="40" height="32" rx="4" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <circle cx="22" cy="26" r="3" fill="#9CA3AF" />
        <path d="M12 38L22 28L28 34L36 26L52 42V44C52 46.2 50.2 48 48 48H16C13.8 48 12 46.2 12 44V38Z" fill="#E5E7EB" />
        <path d="M20 44L44 20" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />
      </svg>

      <!-- 설정 없음 -->
      <svg
        v-else-if="iconType === 'settings'"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="32" cy="32" r="24" fill="#F8F9FA" stroke="#D1D5DB" stroke-width="1.5" />
        <circle cx="32" cy="32" r="4" fill="none" stroke="#9CA3AF" stroke-width="1.5" />
        <path
          d="M32 22V26M32 38V42M42 32H38M26 32H22M38.8 25.2L36.2 27.8M27.8 36.2L25.2 38.8M38.8 38.8L36.2 36.2M27.8 27.8L25.2 25.2"
          stroke="#9CA3AF"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path d="M20 44L44 20" stroke="#EF4444" stroke-width="2" stroke-linecap="round" />
      </svg>
    </div>

    <!-- 텍스트 콘텐츠 -->
    <div class="empty-state__content">
      <h3 class="empty-state__title">{{ displayTitle }}</h3>
      <p v-if="description" class="empty-state__description" v-html="description"></p>
    </div>

    <!-- 추가 액션 슬롯 -->
    <div v-if="$slots.action" class="empty-state__action">
      <slot name="action"></slot>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

/**
 * Empty 상태 컴포넌트 Props
 * 목적: 데이터가 없을 때 사용자에게 친화적인 안내 화면 제공
 */
const props = defineProps({
  /** 제목 문구 (`title`과 동일 용도, 값이 있으면 `title`보다 우선) */
  message: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: '데이터가 없습니다'
  },
  description: {
    type: String,
    default: '표시할 내용이 없습니다.'
  },
  scrollable: {
    type: Boolean,
    default: false
  },
  iconType: {
    type: String,
    default: 'default',
    validator: value =>
      [
        'default',
        'search',
        'document',
        'chart',
        'notification',
        'message',
        'user',
        'folder',
        'image',
        'settings'
      ].includes(value)
  }
});

const displayTitle = computed(() => (props.message ? props.message : props.title));
</script>

<style lang="scss" scoped>
// SCSS 변수 및 유틸리티 import
@use '@/assets/scss/variables.scss';
@use '@/assets/scss/utilities.scss';

.empty-state {
  // 메인 컨테이너 - 중앙 정렬 및 여백 설정
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 60px 32px;
  text-align: center;
  background-color: #fafbfc;
  border: 1px solid #e5e8eb;
  border-radius: 8px;
  position: relative;

  // 스크롤 가능한 버전
  &--scrollable {
    min-height: 200px;
    padding: 40px 24px;
  }

  // 아이콘 영역
  &__icon {
    margin-bottom: 32px;
    opacity: 0.8;
    animation: float 4s ease-in-out infinite;
    position: relative;
    z-index: 1;

    svg {
      filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08));
      transition: transform 0.3s ease;
    }

    &:hover svg {
      transform: scale(1.05);
    }
  }

  // 텍스트 콘텐츠 영역
  &__content {
    max-width: 420px;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease-out 0.2s both;
  }

  // 제목 스타일
  &__title {
    font-size: 20px;
    font-weight: 700;
    color: var(--color-gray-80, #374151);
    margin-bottom: 12px;
    line-height: 1.4;
    letter-spacing: -0.01em;
  }

  // 설명 텍스트 스타일
  &__description {
    font-size: 15px;
    color: var(--color-gray-60, #6b7280);
    line-height: 1.6;
    margin: 0;

    // HTML 요소 스타일링
    strong {
      font-weight: 600;
      color: var(--color-gray-70, #4b5563);
    }

    a {
      color: var(--color-primary-50, #3b82f6);
      text-decoration: none;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  // 사용자명 강조 (기존 기능 유지)
  &__username {
    font-weight: 600;
    color: var(--color-gray-90, #111827);
  }

  // 액션 영역
  &__action {
    position: relative;
    z-index: 1;
    animation: fadeInUp 0.8s ease-out 0.4s both;

    // 버튼 스타일 개선
    :deep(.ui-button) {
      box-shadow: 0 4px 14px rgba(0, 123, 255, 0.15);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 123, 255, 0.25);
      }

      &:active {
        transform: translateY(0);
      }
    }
  }
}

// 애니메이션 정의
@keyframes float {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  25% {
    transform: translateY(-6px) rotate(1deg);
  }
  50% {
    transform: translateY(-12px) rotate(0deg);
  }
  75% {
    transform: translateY(-6px) rotate(-1deg);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// 다크모드 지원 (프로젝트에서 사용할 경우)
@media (prefers-color-scheme: dark) {
  .empty-state {
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
    &__title {
      color: #374151;
    }

    &__description {
      color: #374151;
    }

    &__username {
      color: #374151;
    }
  }
}

// 반응형 처리 - 태블릿
@media (max-width: 768px) {
  .empty-state {
    min-height: 250px;
    padding: 48px 24px;

    &--scrollable {
      min-height: 180px;
      padding: 32px 20px;
    }

    &__icon {
      margin-bottom: 24px;

      svg {
        width: 56px;
        height: 56px;
      }
    }

    &__content {
      margin-bottom: 20px;
    }

    &__title {
      font-size: 18px;
      margin-bottom: 10px;
    }

    &__description {
      font-size: 14px;
    }
  }
}

// 반응형 처리 - 모바일
@media (max-width: 480px) {
  .empty-state {
    min-height: 200px;
    padding: 40px 16px;

    &--scrollable {
      min-height: 160px;
      padding: 28px 16px;
    }

    &__icon {
      margin-bottom: 20px;

      svg {
        width: 48px;
        height: 48px;
      }
    }

    &__title {
      font-size: 16px;
      margin-bottom: 8px;
    }

    &__description {
      font-size: 13px;
      line-height: 1.5;
    }
  }
}

// 접근성 개선 - 모션 감소 선호 시
@media (prefers-reduced-motion: reduce) {
  .empty-state {
    &__icon {
      animation: none;
    }

    &__content,
    &__action {
      animation: none;
      opacity: 1;
      transform: none;
    }
  }
}
</style>
